import React from 'react';
import { useMobile } from '@ff-os/shared-react/hooks/useMobile';
import { useWindowSize } from '@react-hook/window-size';
import classNames from 'classnames';
import { VariantOption } from '../../VariantOption';
import { VariantRadio } from './VariantRadio';
import styles from './VariantRadioGroup.module.scss';

export const VariantRadioGroup = ({ options, onChange, selected, className, aspectWidth, aspectHeight }: Props) => {

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, windowHeight] = useWindowSize();
    const isMobile = useMobile();

    const columnCount = columnCountFor(options.length, windowHeight, isMobile);
    const classes = classNames(styles.options, className, styles[classNameByColumnCount(columnCount)]);

    // Use 1:1 aspect ratio for mobile, otherwise use provided aspect ratio
    const finalAspectWidth = isMobile ? 1 : aspectWidth;
    const finalAspectHeight = isMobile ? 1 : aspectHeight;

    return (
        <div className={classes}>
            {options.map(o => (
                <VariantRadio key={o.value}
                    onClick={() => onChange(o.value)}
                    selected={o.value === selected}
                    aspectWidth={finalAspectWidth}
                    aspectHeight={finalAspectHeight}
                    {...o} />
            ))}
        </div>
    );
};

type MaxColumnCount = 2 | 3 | 4;
type MaxColumnCountClassName = `options-1/${MaxColumnCount}`;

const classNameByColumnCount = (columnCount: MaxColumnCount) => {
    return 'options-1/' + columnCount as MaxColumnCountClassName;
};

const columnCountFor = (
    amountOfOptions: number,
    windowHeight: number,
    isMobile: boolean
): MaxColumnCount => {
    if (isMobile) {
        if (amountOfOptions === 2) {
            return 2;
        } else {
            return 3;
        }
    } else if (windowHeight <= 600) {
        return 4;
    } else if (windowHeight <= 900) {
        return 3;
    } else if (amountOfOptions % 3 === 0) {
        return 3;
    } else if (amountOfOptions === 2) {
        return 2;
    } else {
        return 4;
    }
};

type Props = {
    selected?: string;
    options: VariantOption[];
    onChange: (value: string) => void;
    className?: string;
    aspectWidth?: number;
    aspectHeight?: number;
};